module.exports = __webpack_public_path__ + "media/video.337d1409.mp4";